import ErrorMessageList from './errorMessageList.js';

let ErrorMessageCookieService = function() {
    "use strict";

    let ERROR_MESSAGES_STORAGE_KEY = 'errorMessage';

    // ---------------------------------------------
    //
    //        Define all public methods.
    //
    // ---------------------------------------------
    let publicMethods = {
        getErrorMessages : function() {
            let errorMessages = new ErrorMessageList();
            let errorMessagesData = getStoredErrorMessages();
            if (errorMessagesData !== null) {
                errorMessages = new ErrorMessageList(errorMessagesData);
            }
            return errorMessages;
        },
        setErrorMessages : function(errorMessages) {
            if (errorMessages != null && errorMessages instanceof ErrorMessageList) {
                writeErrorMessagesToStorage(errorMessages.toJSON());
            } else {
                writeErrorMessagesToStorage(errorMessages);
            }
        },
        resetErrorMessagesStorage : function(){
            writeErrorMessagesToStorage(null);
        }
    };

    // ---------------------------------------------
    //
    //        Define all private methods.
    //
    // ---------------------------------------------
    function getStoredErrorMessages() {
        let errorMessages = null;
        let cookieVal = localStorage.getItem(ERROR_MESSAGES_STORAGE_KEY);
        if (cookieVal !== null && cookieVal !== undefined) {
            errorMessages = JSON.parse(cookieVal);
        }
        return errorMessages;
    }

    function writeErrorMessagesToStorage(errorMessages) {
        if (errorMessages !== null) {
            localStorage.setItem(ERROR_MESSAGES_STORAGE_KEY, JSON.stringify(errorMessages));
        }
        else {
            localStorage.setItem(ERROR_MESSAGES_STORAGE_KEY, null);
        }
    }

    return publicMethods;
}();

export default ErrorMessageCookieService;